// extracted by mini-css-extract-plugin
export default {"Content":"_Content--AsfDT","Item":"_Item--x29kU"};